import { Card } from "antd";
import { capabRedirectArrow, capabRedirectArrowFilled } from "../../../assets";
import { useState } from "react";

const { Meta } = Card;
const CapaCard = ({ title, desc, mainImage, flipDelay }) => {
  const [isHovered, setIsHovered] = useState(false);
  const [imageSrc, setImageSrc] = useState(capabRedirectArrow);

  const handleMouseEnter = () => {
    setIsHovered(true); // Set hover state to true
    setImageSrc(capabRedirectArrowFilled); // Change image source on hover
  };

  const handleMouseLeave = () => {
    setIsHovered(false); // Set hover state to false
    setImageSrc(capabRedirectArrow); // Reset image source when hover ends
  };
  return (
    <>
      <Card
        className="capab-card"
        // hoverable
        onMouseEnter={handleMouseEnter}
        onMouseLeave={handleMouseLeave}
        data-aos="flip-right"
        data-aos-duration="700"
        data-aos-delay={flipDelay}
      >
        <div>
          <div className="why-us-card-img capab-image-backlground">
            <img src={mainImage} alt={title} />
          </div>
          <div className="member-card-name" style={{ marginTop: "28px" }}>
            {title}
          </div>
          <div className="member-card-designation t">{desc} </div>
        </div>
        {/* <img          //usefull for later
          src={imageSrc}
          className={
            imageSrc === capabRedirectArrow
              ? "capab-redirect-img"
              : "capab-redirect-img capab-redirect-img-filled"
          }
        /> */}
      </Card>
    </>
  );
};
export default CapaCard;
